<template>
  <ais-refinement-list
    v-slot="{
        items,
        refine
      }"
   :attribute="facet">

      <div
        v-show="items.length"
        class="pb-5"
      >
        <div
          v-if="!hideTitle"
          class="font-medium border-b mb-2"
        >
          <span>{{ refinementListTitle }}</span>
        </div>
        <PricePicker v-if="facet === TYPESENSE_ATTRIBUTE.PRICE" />
        <RatingMenu v-else-if="facet === TYPESENSE_ATTRIBUTE.AVG_RATING" />
        <CheckboxPicker
          v-else
          :items="items"
          :refine="refine"
          :facet="facet"
        />
      </div>


  </ais-refinement-list>
</template>

<script lang="ts">

import { AisRefinementList } from 'vue-instantsearch/vue3/es';
import { TYPESENSE_ATTRIBUTE } from '~~/constants/typesense';

export default defineComponent({
  name: 'CustomRefinementList',
  components: {

    AisRefinementList,
  },
  props: {
    facet: {
      type: String,
      required: true,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {

    const i18n = useI18n();

    const refinementListTitle = computed(() => {

      if (props.facet === TYPESENSE_ATTRIBUTE.BRAND) {

        return i18n.t('brand');

      }

      if (props.facet === TYPESENSE_ATTRIBUTE.AVG_RATING) {

        return i18n.t('Ratings');

      }

      if (props.facet === TYPESENSE_ATTRIBUTE.PRICE) {

        return i18n.t('Price');

      }

      return props.facet;

    });

    return {
      refinementListTitle,
      TYPESENSE_ATTRIBUTE,
    };

  },
});

</script>
